// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1QwEe","right":"Footer_right__1mAxT","buttons":"Footer_buttons__3d7IR"};